import { WarningOutlined } from '@ant-design/icons';
import styled, { css } from 'styled-components';

export const ContentWrapper = styled.div<{ my?: number }>`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  background-color: ${({ theme }) => theme.palette.cornsilk};
  border: 1px solid ${({ theme }) => theme.palette.wheat};
  border-radius: 8px;
  padding: 20px 10px;
  color: ${({ theme }) => theme.palette.peru};
  font-size: 18px;

  ${({ my }) =>
    my &&
    css`
      margin: ${my}px 0;
    `}

  a {
    color: ${({ theme }) => theme.palette.lightBlack};
    &:hover {
      color: ${({ theme }) => theme.palette.peru};
    }
  }
`;

export const WarningIcon = styled(WarningOutlined)`
  font-size: 24px;
`;
